module.exports = __webpack_public_path__ + "static/media/wallet.3fc8e0ba.svg";